import { createSlice } from "@reduxjs/toolkit";

export interface LotteryHallState {
  isEnteringLotteryHall: boolean;
  isFinishingLotteryHallRound: boolean;
  isLotteryHallOwnerWithdrawing: boolean;
}

const initialState: LotteryHallState = {
  isEnteringLotteryHall: false,
  isFinishingLotteryHallRound: false,
  isLotteryHallOwnerWithdrawing: false,
};

const lotteryHallSlice = createSlice({
  name: "lotteryHall",
  initialState,
  reducers: {
    lotteryHallEnterPending: (state) => {
      state.isEnteringLotteryHall = true;
    },
    lotteryHallEnterSettled: (state) => {
      state.isEnteringLotteryHall = false;
    },
    lotteryHallFinishPending: (state) => {
      state.isFinishingLotteryHallRound = true;
    },
    lotteryHallFinishSettled: (state) => {
      state.isFinishingLotteryHallRound = false;
    },
    lotteryHallOwnerWithdrawPending: (state) => {
      state.isLotteryHallOwnerWithdrawing = true;
    },
    lotteryHallOwnerWithdrawSettled: (state) => {
      state.isLotteryHallOwnerWithdrawing = false;
    },
  },
});

export const {
  lotteryHallEnterPending,
  lotteryHallEnterSettled,
  lotteryHallFinishPending,
  lotteryHallFinishSettled,
  lotteryHallOwnerWithdrawPending,
  lotteryHallOwnerWithdrawSettled,
} = lotteryHallSlice.actions;

export default lotteryHallSlice.reducer;